import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getNotReportedSchedulePositions } from 'actions/schedule';
import Card, { CardsContainer, CardTitle } from 'components/Cards/Card';
import Redirect from 'components/Redirect/Redirect';
import { ROLE_ADMINISTRATOR, ROLE_TEACHER } from 'constants/roles';
import { getRootUrl } from 'helpers/url';
import Moment from 'moment';
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner } from 'UI';
import { Button, getActiveLanguage } from '@haldor/ui';
import DateTime from '_class/DateTime';
import { setPageTitle } from 'actions/header';

var AttendanceOverview = /*#__PURE__*/function (_Component) {
  _inherits(AttendanceOverview, _Component);

  var _super = _createSuper(AttendanceOverview);

  function AttendanceOverview(props) {
    var _this;

    _classCallCheck(this, AttendanceOverview);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('not-reported-lessons'));
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var school = _this.props.user.schools.find(function (school) {
        return school.id == _this.props.activeSchool;
      });

      if (school != null) {
        var isTeacher = school.userRoles.find(function (role) {
          return role.toUpperCase() == ROLE_TEACHER;
        });
        var isAdmin = school.userRoles.find(function (role) {
          return role.toUpperCase() == ROLE_ADMINISTRATOR;
        });

        _this.setState({
          allowed: isTeacher != null || isAdmin != null
        });

        _this.setState({
          admin: isAdmin != null
        });

        var role = isAdmin != null ? ROLE_ADMINISTRATOR : ROLE_TEACHER;

        _this.props.getNotReportedSchedulePositions(role, _this.state.startDate.format('YYYY-MM-DD'), _this.state.endDate.format('YYYY-MM-DD')).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onStartDateChange", function (startDate) {
      if (startDate == null) {
        return false;
      }

      _this.setState({
        startDate: startDate,
        endDate: Moment(startDate).add(6, 'days')
      });

      localStorage.setItem("attendance-start-date", new DateTime(startDate).getDateStamp());
      localStorage.setItem("attendance-end-date", new DateTime(Moment(startDate).add(6, 'days')).getDateStamp());
    });

    _defineProperty(_assertThisInitialized(_this), "onEndDateChange", function (endDate) {
      if (endDate == null) {
        return false;
      }

      _this.setState({
        endDate: endDate,
        startDate: Moment(endDate).subtract(6, 'days')
      });

      localStorage.setItem("attendance-start-date", new DateTime(Moment(endDate).subtract(6, 'days')).getDateStamp());
      localStorage.setItem("attendance-end-date", new DateTime(endDate).getDateStamp());
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterChange", function (event) {
      event.preventDefault();
      var filter = event.target.value;

      _this.setState({
        filter: filter
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDateFilterChange", function () {
      _this.setState({
        loading: true
      });

      var role = _this.state.admin ? ROLE_ADMINISTRATOR : ROLE_TEACHER;

      _this.props.getNotReportedSchedulePositions(role, _this.state.startDate.format('YYYY-MM-DD'), _this.state.endDate.format('YYYY-MM-DD')).then(function () {
        _this.setState({
          loading: false
        });
      });
    });

    Moment.locale(getActiveLanguage());
    var start = Moment().subtract(1, 'days');
    var end = Moment();
    var startDateLocalStorage = localStorage.getItem('attendance-start-date');
    var endDateLocalStorage = localStorage.getItem('attendance-end-date');

    if (!Moment(startDateLocalStorage).isValid()) {
      startDateLocalStorage = null;
    }

    if (!Moment(endDateLocalStorage).isValid()) {
      endDateLocalStorage = null;
    }

    if (startDateLocalStorage != null && endDateLocalStorage != null) {
      start = Moment(startDateLocalStorage);
      end = Moment(endDateLocalStorage);
    }

    _this.state = {
      loading: true,
      startDate: start,
      endDate: end,
      allowed: null,
      admin: false,
      filter: ''
    };
    return _this;
  }

  _createClass(AttendanceOverview, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.loading || this.state.allowed == null) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      if (this.state.allowed != null && !this.state.allowed) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/"
        });
      }

      var sections = [];

      if (this.props.schedulePositions != null) {
        this.props.schedulePositions.forEach(function (position) {
          if (sections.indexOf(position.section.title) == -1) {
            sections.push(position.section.title);
          }
        });
      }

      var schedulePositions = this.props.schedulePositions;

      if (this.state.filter != '') {
        schedulePositions = schedulePositions.filter(function (position) {
          return position.section.title == _this2.state.filter;
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section form",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half"
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('select-date')), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static"
      }, /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.startDate,
        onChange: this.onStartDateChange,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        popperModifiers: {
          preventOverflow: {
            enabled: false
          },
          positionFixed: true
        },
        popperPlacement: "bottom-start",
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.startDate))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static last"
      }, /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.endDate,
        onChange: this.onEndDateChange,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        popperModifiers: {
          preventOverflow: {
            enabled: false
          },
          positionFixed: true
        },
        popperPlacement: "bottom-start",
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.endDate)))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('section')), /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        onChange: this.onFilterChange,
        value: this.state.filter
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, this.props.translate('filter-results')), sections.map(function (section) {
        return /*#__PURE__*/React.createElement("option", {
          key: 'select-' + section,
          value: section
        }, section);
      })))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '0.75rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onDateFilterChange
      }, this.props.translate('update')), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }), /*#__PURE__*/React.createElement(CardsContainer, null, schedulePositions.map(function (position) {
        return /*#__PURE__*/React.createElement(Card, {
          style: {
            minHeight: '2em'
          },
          key: position.id + "-" + position.section.id,
          target: getRootUrl() + 'lesson/' + position.id + '?redirect=list'
        }, /*#__PURE__*/React.createElement("div", {
          className: "card-meta"
        }, position.section.title), /*#__PURE__*/React.createElement("div", {
          className: "card-meta",
          style: {
            marginLeft: '0.65rem'
          }
        }, new DateTime(position.startTime).getLongDateWithTime()), /*#__PURE__*/React.createElement(CardTitle, null, position.title));
      }), schedulePositions.length == 0 ? /*#__PURE__*/React.createElement("div", {
        className: "color--meta text--center weight--bold"
      }, this.props.translate('no-results')) : null));
    }
  }]);

  return AttendanceOverview;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    activeSchool: state.user.activeSchool,
    user: state.user.currentUser,
    schedulePositions: state.schedule.schedulePositions,
    languages: state.Languages.languages
  };
}

export default connect(mapStateToProps, {
  getNotReportedSchedulePositions: getNotReportedSchedulePositions,
  setPageTitle: setPageTitle
})(AttendanceOverview);